module.exports = __webpack_public_path__ + "img/63x63.b73794d3.png";